import { jsx as _jsx } from "react/jsx-runtime";
import { useOffRampToAmazon } from 'src/hooks';
import { Link } from 'src/common/styled';
export const ExternalLink = ({ children, href, id, underline = false, source }) => {
    const offRampToAmazon = useOffRampToAmazon();
    const openExternalLink = (e) => {
        e.preventDefault();
        const url = e.currentTarget.href;
        offRampToAmazon(url, source);
    };
    return (_jsx(Link, { "data-testid": id, underline: underline, href: href, onClick: openExternalLink, children: children }));
};
